// The css class that this following behaviour is applied to.
var secondaryNavClass = 'su-secondary-nav';

// All Secondary navs.
export var secondaryNavs = document.querySelectorAll('.' + secondaryNavClass);